export default __webpack_public_path__ + "static/media/WWYK.58c53568.gif";